import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/flipboard': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 32h448v448h-448v-448zM358.4 211.2v-89.6h-268.8v268.8h89.6v-89.6h89.6v-89.6h89.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/flipboard.js
// module id = 829
// module chunks = 0